import CustomTable, { ICustomTableColumn } from '../Table';
import SkeletonLoader from './index';

interface IListSkeletonProps<T extends object> {
  columns: ICustomTableColumn<T>[];
}

const ListSkeleton = <T extends object>({ columns }: IListSkeletonProps<T>) => {
  return (
    <div className="flex flex-col gap-5 h-full">
      {/* Top Bar: Search, Filters, Add Button */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {/* Search Input Skeleton */}
          <SkeletonLoader className="h-11 w-72 rounded-lg" variant="rect" />
        </div>

        {/* Add Button Skeleton */}
        <SkeletonLoader className="h-11 w-40 rounded-lg" variant="rect" />
      </div>

      {/* Page Title / Section Header */}
      <div className="w-full">
        <SkeletonLoader className="h-7 w-48 rounded-md" variant="text" />
      </div>

      {/* Table Skeleton via CustomTable */}
      <CustomTable columns={columns} dataSource={[]} isLoading={true} />
    </div>
  );
};

export default ListSkeleton;
